export const XL_VIEWPORT_WIDTH = 1200;
export const LARGE_VIEWPORT_WIDTH = 992;
export const MEDIUM_VIEWPORT_WIDTH = 768;
export const SMALL_VIEWPORT_WIDTH = 320;

export const isSmallViewPort = () => window.innerWidth <= MEDIUM_VIEWPORT_WIDTH;

export const isBelowLgViewPort = () => window.innerWidth < XL_VIEWPORT_WIDTH;



// WEBPACK FOOTER //
// ./src/utils/viewports.js